import { render } from "./Step.vue?vue&type=template&id=5acbd6ca&scoped=true&ts=true"
import script from "./Step.vue?vue&type=script&lang=ts"
export * from "./Step.vue?vue&type=script&lang=ts"

import "./Step.vue?vue&type=style&index=0&id=5acbd6ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acbd6ca"]])

export default __exports__